import React from 'react'
import { authRoles } from '../../auth/authRoles'

const PortalRoutes = [

    {
        path: '/Portals/viewerportal',
        component: React.lazy(() => import('./ViewerPortal')),
        auth: authRoles.viewerPortal,
    },
    {
        path: '/Portals/organization_admin_portal',
        component: React.lazy(() => import('./OrgAdminPortal')),
        auth: authRoles.orgAdmin,
    },
    {
        path: '/Portals/organization_contributor_portal',
        component: React.lazy(() => import('./OrgContributorPortal')),
        auth: authRoles.orgContributor,
    },
    {
        path: '/contributor/portal',
        component: React.lazy(() => import('./ContributorPortal')),
        auth: authRoles.individualContributorPortal,                           // TODO needs to change
    },
    {
        path: '/admin/portal',
        component: React.lazy(() => import('./AdminPortal')),
        auth: authRoles.AdminPortal,                           // TODO needs to change
    },
]

export default PortalRoutes